/*
 * Readmore list class for vertically expanding list of links
 *
 * Version: 1.0
 *
 * Author: Zwaar Contrast
 *
 * Contact: postduif@zwaarcontrast.nl
 *
 * Dependencies: jQuery (1.11.x)
 * 
 */
(function($, window, document, undefined) {
	"use strict";

	/*
	 * 	In the constructor we wrap the element on which the plugin is called on in a jQuey object 
	 *	and expose the passed on options for usage in the init functionr
	 */
	var ReadMoreList = function(elem, options, texts) {
		this.el = elem;
		this.element = $(elem);
		this.options = options;
		this.optionsTexts = texts;
	};

	ReadMoreList.prototype = {

		/*
		 *	Default values, which can be overwritten by merging with config on initialisation
		 */
		defaults:{
			resizeDebounce: 50,
			linksVisible: 3,
			toggleAble: false,
			toggle: null,
			toggleHiddenClass:'is-window-readmore-loadmore-link-invisible'
		},
		texts:{
			readMore: 'laad meer',
			readLess: 'minder zien'
		},

		/*
		 *	Initialisation funtion, read passed config and call necessary functions to launch our plugin like binding events and setting status variables
		 */
		init: function() {
			//Get the options/texts and merge with defaults
			this.config = $.extend({}, this.defaults, this.options);
			this.texts = $.extend({}, this.texts, this.optionsTexts);

			//Status
			this.expanded = false;

			//Call functions for initialisation
			this.getElements();

			//Check links found and enough to bind our clicks/resize
			if(this.links.length>0 && this.links.length>this.config.linksVisible){
				//Bind events
				this.bindResize();
				this.bindClick();

				//Initial state
				this.toggleVisibility(this.expanded);
			}else{
				if(this.toggle)
					this.toggle.addClass(this.config.toggleHiddenClass);
			}

			return this;
		},
		getElements:function(){
			//Get necessary elements
			this.window = $(window);
			this.toggle = this.config.toggle;
			this.links = this.element.find('li');
		},
		bindResize:function(){
			//Variables and reference to self
			var TO = false, _self = this;

			//We make this construct to debounce the resize event,
			//so it doesn't call our functions a bazillion times
			this.window.resize(function() {
				if (TO !== false){
					clearTimeout(TO);
				}
				TO = setTimeout(function(){
					//Do stuff here
					_self.toggleVisibility(_self.expanded);
				}, _self.config.resizeDebounce);
			});
		},
		bindClick:function(){
			//Variables and reference to self
			var _self = this;

			//Bind click
			this.toggle.click(function(ev){
				ev.preventDefault();

				//Check toggleable config
				if(!_self.expanded || (_self.expanded && _self.config.toggleAble)){
					_self.toggleVisibility(!_self.expanded);
				}
				return false;
			});
		},
		toggleVisibility:function(state){
			//Check show or hide
			if(state){
				//Get the height of all the links and set
				this.element.height(this.getListHeight());

				//Set state and text
				this.expanded = true
				if(!this.config.toggleAble){
					this.toggle.addClass(this.config.toggleHiddenClass);
				}else{
					this.toggle.text(this.texts.readLess);
				}
			}else{
				//Get the height of elements shown initially
				this.element.height(this.getListHeight(this.config.linksVisible));

				//Set state and text
				this.expanded = false
				if(this.config.toggleAble){
					this.toggle.text(this.texts.readMore);
				}
			}
		},
		getListHeight:function(amount){
			var height = 0;

			//Calculate the height by looping through the links, break when amount is defined and reached
			for (var i = 0 ; i <this.links.length; i++) {
				height += $(this.links[i]).outerHeight();
				if(amount && amount - 1 == i){
					return height;
				}
			};

			return height;
		}
	};

	//Extend Jquery with the LinkPositioner function/object
	$.fn.ReadMoreList = function(options,texts) {
		//Do for each of the passed elements
		return this.each(function() {
			//Construct new LinkPositioner object and call initialisation function
			new ReadMoreList(this, options,texts).init();
		});
	};
})(jQuery, window, document);